import axios from "axios";
import {apiWeb} from '../../api';

export default axios.create({
    baseURL:
    apiWeb
});